// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App_Types_Json$DvmAdminFrontendFr from "../../../common/types/App_Types_Json.bs.js";

function toString(status) {
  switch (status) {
    case /* SO */0 :
        return "SO";
    case /* CL */1 :
        return "CL";
    case /* VE */2 :
        return "VE";
    case /* VD */3 :
        return "VD";
    case /* RR */4 :
        return "RR";
    case /* RC */5 :
        return "RC";
    case /* PG */6 :
        return "PG";
    case /* EP */7 :
        return "EP";
    case /* ES */8 :
        return "ES";
    case /* RP */9 :
        return "RP";
    case /* RS */10 :
        return "RS";
    case /* SM */11 :
        return "SM";
    case /* TT */12 :
        return "TT";
    case /* AD */13 :
        return "AD";
    case /* AP */14 :
        return "AP";
    case /* AS */15 :
        return "AS";
    case /* NOTSET */16 :
        return "";
    
  }
}

function fromString(status) {
  switch (status) {
    case "" :
        return /* NOTSET */16;
    case "AD" :
        return /* AD */13;
    case "AP" :
        return /* AP */14;
    case "AS" :
        return /* AS */15;
    case "CL" :
        return /* CL */1;
    case "EP" :
        return /* EP */7;
    case "ES" :
        return /* ES */8;
    case "PG" :
        return /* PG */6;
    case "RC" :
        return /* RC */5;
    case "RP" :
        return /* RP */9;
    case "RR" :
        return /* RR */4;
    case "RS" :
        return /* RS */10;
    case "SM" :
        return /* SM */11;
    case "SO" :
        return /* SO */0;
    case "TT" :
        return /* TT */12;
    case "VD" :
        return /* VD */3;
    case "VE" :
        return /* VE */2;
    default:
      return ;
  }
}

var Decco = App_Types_Json$DvmAdminFrontendFr.MakeStringableJsonType({
      toString: toString,
      fromString: fromString
    });

export {
  toString ,
  fromString ,
  Decco ,
}
/* Decco Not a pure module */
